<script context="module">
	export async function updateLinkState(list, hash, n) {
		if (n > 0) {
			let current = hash.splice(0, 1);
			let isExist = false;
			if (hash.length > 0) {
				hash[0] = current + "-" + hash[0];
			}
			if (list) {
				list.forEach((link) => {
					link.active = false;
					link.selected = false;
					if (link.hash == current[0]) {
						isExist = true;
						link.active = true;
						link.selected = true;
						isMenuHeaderDataNeeded.set(link.options.headerData);
						if (link.sublist) {
							isSublistClosed.set(false);
							updateLinkState(link.sublist, hash, n - 1);
						}
					}
				});
			}
			if (!isExist) {
				changeHash("menu", list[0].hash, {
					navigate: true,
				});
				list[0].active = true;
				list[0].selected = true;
				isMenuHeaderDataNeeded.set(list[0].options.headerData);
				location.reload();
			}
		}
	}
</script>

<script>
	export let data;

	import { scale, slide } from "svelte/transition";

	import List from "./List.svelte";
	import MenuHeader from "./MenuHeader.svelte";
	import Banner from "./Banner.svelte";

	import {
		isWideScreen,
		isMenuClosed,
		isMobile,
		isSublistClosed,
		isMenuHeaderDataNeeded,
		menuEntity,
	} from "../../../stores/variables";
	import {
		profileData,
		currentActiveObjectData,
		menuData,
	} from "../../../stores/data";

	import {
		changeHash,
		getHashByType,
		navigateByTypeHash,
	} from "../../../scripts/change_hash";
	import { logout } from "../../../scripts/logout";
	import { request } from "../../../scripts/request";

	let bannerData;
	if ($menuEntity == "clinic") {
		bannerData = request.fetchLocalData("banner");
	}

	if (!data.type) data.type = "";

	export function updateData() {
		data = data;
		$menuData = data;
	}

	function changeMenuState() {
		$isMenuClosed = !$isMenuClosed;
	}

	function updateLinkHash(list) {
		list.forEach((link) => {
			if (link.sublist) {
				link.sublist.forEach((sublink) => {
					sublink.hash = link.hash + "-" + sublink.hash;
				});
				updateLinkHash(link.sublist);
			}
		});
	}

	function checkHash() {
		let hash = window.location.hash;
		if (hash[0] == "#") hash = hash.slice(1);
		if (hash) {
			hash.split("/").forEach((raw) => {
				let temp = raw.split("=");
				if (temp[0] == data.type) {
					let _temp = temp[1].split("-");
					$isSublistClosed = true;
					updateLinkState(data.list, _temp, _temp.length);
				}
			});
		}
		return hash;
	}

	function getFirshHash(list) {
		let index = 0;
		let find = false;
		list.forEach((link, i) => {
			if (!link.options.hidden && !find) {
				index = i;
				find = true;
			}
		});
		if (list[index].sublist) {
			return getFirshHash(list[index].sublist);
		}
		return list[index].hash;
	}

	if (data && data.list) {
		updateLinkHash(data.list);
		let hashes = window.location.hash;
		let isExist2 = false;
		if (hashes) {
			hashes = hashes.split("/");
			hashes.forEach((_hash) => {
				let temp = _hash.split("=");
				if (temp[0][0] == "#") temp[0] = temp[0].slice(1);
				if (temp[0] == data.type) {
					isExist2 = true;
					let hash = checkHash();
					hash = getHashByType(hash, data.type);
					navigateByTypeHash(data.type, hash);
				}
			});
		}
		if (!isExist2) {
			let hash = getFirshHash(data.list);
			changeHash(data.type, hash, {
				navigate: true,
				callback: function () {
					checkHash();
				},
			});
		}
	}

	let userData = {
		name: "Пользователь",
	};
	let user_menu;
	let user_menu_active;

	$profileData.label && (userData.name = $profileData.label);
	+$profileData.Image && (userData.img = $profileData.Image);
</script>

<div
	class="menu {$isMenuClosed ? 'closed' : 'opened scrollbar'} {$isMobile
		? 'mobile'
		: 'not_mobile'}"
	style="margin-bottom: {!$isSublistClosed && $isMenuClosed && !$isWideScreen
		? 60
		: 0}px"
>
	{#if data}
		{#if data.logo && $isWideScreen}
			<div class="menu__logo">
				<img src={data.logo} alt="" />
			</div>
		{/if}
		{#if !$isWideScreen}
			<div class="menu__mobile-header">
				<div class="menu__mobile-header-content">
					{#if $isMenuClosed}
						{#if data.mobile_logo}
							<div class="menu__mobile-logo">
								<img src={data.mobile_logo} alt="logo" />
							</div>
						{/if}
					{:else if userData}
						<div
							class="user"
							on:click={() => {
								user_menu_active = !user_menu_active;
							}}
						>
							<div class="user__logo">
								<img
									src={userData.img
										? userData.img
										: "/img/user.svg"}
									alt=""
								/>
							</div>
							<div class="user__name">
								<span>{userData.name}</span>
							</div>
						</div>
					{/if}
					<span
						class="menu__burger no-highlight"
						on:click={() => changeMenuState()}
					>
						{#if $isMenuClosed}
							<i class="fas fa-bars " transition:scale />
						{:else}
							<i class="fas fa-times " transition:scale />
						{/if}
					</span>
				</div>
				{#if user_menu_active && !$isMenuClosed}
					<div
						transition:slide
						class="user__menu"
						class:selected={user_menu_active}
						bind:this={user_menu}
					>
						<span
							on:click={() => {
								logout("exit");
							}}>Выход</span
						>
					</div>
				{/if}
			</div>
		{:else if $isMenuHeaderDataNeeded && $currentActiveObjectData}
			<MenuHeader
				data={$currentActiveObjectData}
				menuEntity={$menuEntity}
			/>
		{/if}
		<div
			class="menu__content scrollbar {$isMobile
				? 'mobile'
				: 'not_mobile'}"
		>
			{#if data.list}
				<List data={data.list} {updateData} type={data.type} />
			{/if}
		</div>
		{#if bannerData}
			<Banner data={bannerData} />
		{/if}
	{/if}
</div>

<style lang="scss">
	.user {
		display: flex;
		align-items: center;
		height: 100%;
		padding: 0 24px;
		flex-grow: 1;
		&__name {
			color: var(--text-main-1);
			display: flex;
			align-items: center;
			font-size: 16px;
			font-weight: bold;
			line-height: 24px;
		}

		&__logo {
			margin: 0 16px 0 0;
			height: 48px;
			width: 48px;
			display: flex;
			flex-shrink: 0;
			border-radius: 50%;
			overflow: hidden;
			> img {
				height: 100%;
				width: 100%;
				object-fit: cover;
			}
		}

		&__menu {
			margin: 12px 0 12px 56px;
			display: flex;
			flex-wrap: wrap;
			> span {
				display: flex;
				align-self: flex-start;
				cursor: pointer;
				padding: 3px 24px;
				background: var(--bg-black-1-active);
				color: var(--text-main-1);
				border-radius: 4px;
				font-size: 13px;
				line-height: 20px;
			}
		}
	}
	.menu {
		display: flex;
		flex-direction: column;
		flex-shrink: 0;
		min-width: 280px;
		background-color: var(--bg-black-1);
		position: relative;

		&__mobile {
			&-logo {
				display: flex;
				align-items: center;
				width: 240px;
				padding-left: 24px;

				> img {
					height: 100%;
					width: 100%;
				}
			}
			&-header {
				display: flex;
				flex-direction: column;

				@media (min-width: 992px) {
					display: none;
				}
				&-content {
					align-items: center;
					display: flex;
					width: 100%;
				}
			}
		}

		&__burger {
			margin-left: auto;
			padding: 34px;
			height: 0;
			width: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			position: relative;

			> i {
				position: absolute;
				color: var(--text-main-1);
				font-size: 24px;
			}
		}

		&__logo {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 64px;
			width: 100%;
			align-self: center;
			padding: 12px 24px;
			background: var(--bg-main-1);
			border-bottom: 1px solid var(--border-gray-1);

			> img {
				height: 100%;
				width: 100%;
				object-fit: contain;
			}
		}
	}

	.menu.opened {
		height: 100vh;
		.menu {
			&__mobile {
				&-header {
					border-bottom: 1px solid var(--border-gray-2);
				}
			}
		}
	}
</style>
